<template>
    <button @click="showModal = true" :disabled="disabled" title="Export report files">
        <span>
            Export <font-awesome-icon icon="file-export" />
        </span>

        <teleport to="body">
            <modal v-if="showModal" @reject="showModal = false" @accept="exportAction" :title="`Export ${entityNamePlural}`"
            :acceptText="`Export ${selectionCount} ${entityNameForCount}`">
                <div class="form-row">
                    <span>Choose a report format</span>
                    <select v-model="selectedExportOption" autofocus>
                        <option v-for="opt in exportOptions" :value="opt.value">{{ opt.label }}</option>
                    </select>
                </div>
            </modal>
        </teleport>
    </button>
</template>
<script>

import Modal from '../Modal.vue';
import Teleport from 'vue2-teleport';
import api from '@/services/api';
import { notify } from '@/services/notify';

const CERTIFICATE_FILE = { label: "Certificate single file", value: "certificate", ext: "pdf" };
const CERTIFICATE_ZIP = { label: "Certificate zipped files", value: "certificate_zip", ext: "zip" };
const CSV_FILE = { label: "CSV single file (row per disk)", value: "csv", ext: "csv" };
const CSV_FLAT_FILE = { label: "CSV single file", value: "csv_flat", ext: "csv" };
const JSON_FILE = { label: "JSON single file", value: "json", ext: "json" };
const JSON_ZIP = { label: "JSON zipped files", value: "json_zip", ext: "zip" };

export default {
    name: 'ExportAction',
    components: {
        Modal,
        Teleport,
    },
    props: {
        disabled: Boolean,
        entityName: String,
        entityNamePlural: String,
        entityNameForCount: String,
        selectionCount: Number,
        selectOrFilter: Object,
        exportResource: String
    },
    data() {
        return {
            selectedExportOption: null,
            showModal: false,
        }
    },
    async mounted() {
        this.selectedExportOption = this.exportOptions[0].value;
    },
    methods: {
        async exportAction() {
            await api.postJSON(`/${this.exportResource}/export-task`, {
              type: this.selectedExportOption, ...this.selectOrFilter,
            });

            await this.$store.dispatch('task/fetchTasks');
            this.$store.commit('task/setTasksHaveUpdates', true);
            notify().success("Your task is in progress. Please check the task list to see when the export is ready.");

            this.showModal = false;
        },
    },
    computed: {
        exportOptions() {
            if (this.entityName.includes('computer')) {
                return [CERTIFICATE_FILE, CERTIFICATE_ZIP, CSV_FILE, CSV_FLAT_FILE, JSON_FILE, JSON_ZIP];
            }
            else if (this.entityName.includes('enrollment')) {
                return [CSV_FLAT_FILE, JSON_FILE, JSON_ZIP];
            }
            else {
                return [CERTIFICATE_FILE, CERTIFICATE_ZIP, CSV_FLAT_FILE, JSON_FILE, JSON_ZIP];
            }
        },
    }
}
</script>
<style scoped>
.form-row {
    display: grid;
    grid-template-columns: 2fr 4fr;
    gap: 6px;
    padding: 0;
}
.form-row select {
    border: 1px solid rgb(118, 118, 118);
    border-radius: 2px;
    font-size: 14px;
    background-color: white;
    height: 28px;
}

.form-row select:focus {
    outline: rgba(102, 179, 227, 0.75) auto 1px !important;
    outline-offset: 0px;
    z-index: 99;
}
</style>
